module.exports = __webpack_public_path__ + "static/media/send.618ff546.svg";